import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { candidateSchema, defaultCandidateFormValues, type CandidateFormValues } from './CandidateAddSection.schema';

export function useCandidateAddSectionForm(defaultValues?: Partial<CandidateFormValues>) {
    return useForm<CandidateFormValues>({
        defaultValues: { ...defaultCandidateFormValues, ...defaultValues },
        resolver: zodResolver(candidateSchema),
        mode: 'onSubmit',
    });
}
